import { Injectable, OnDestroy } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import {
  gettingAuthUserDataSelector,
} from '@geekbears/gb-ngrx-auth-basic';
import { Store } from '@ngrx/store';
import { isNil } from 'lodash';
import { combineLatest, filter, map, Observable, Subject, take } from 'rxjs';
import { Roles } from '@utils/roles';
import { APP_ROUTES } from '@typings/app-routes.constant';
import { appAuthenticatedUserSelector } from '@core/application';

@Injectable({
  providedIn: 'root',
})
export class OnFirstTimeLoginGuard implements CanActivate, OnDestroy {
  destroy$: Subject<void> = new Subject();

  constructor(private router: Router, private store$: Store) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // let currentUser: any = JSON.parse(localStorage.getItem('s_user') || '{}');

    return combineLatest([
      this.store$.select(appAuthenticatedUserSelector),
      this.store$.select(gettingAuthUserDataSelector),
    ]).pipe(
      filter(([user, fetching]) => {
        return !fetching;
      }),
      take(1),
      map(([user, fetching]) => {
        if (isNil(user)) {
          this.router.navigateByUrl(
            APP_ROUTES.authentication['sign-in'].fullPath
          );
          return false;
        }

        if (user.isSuperAdmin) {
          return true;
        } else {
            // console.log('user data--------',user);
          if (isNil(user.accountConfirmedAt && !user.otpVerified)) {
            this.router.navigateByUrl(
              APP_ROUTES.authentication['confirm-account'].fullPath
            );
            return false;
          }
          if (user.isManager) {
          
            if (isNil(user._companyId)) {
              // this.router.navigateByUrl(
              //   APP_ROUTES.authentication['company-information'].fullPath
              // );
              this.router.navigateByUrl(
                APP_ROUTES.authentication['admin-info'].fullPath
              );
              return false;
            } else if (isNil(user.company?._subscription) && !user.isSubscriptionBypassed && !user.company?.isSubscriptionBypassed) {
              this.router.navigateByUrl(
                APP_ROUTES.authentication['pick-plan'].fullPath
              );
              return false;
            }
          } else {
            if (
              user.firstName == '##N/A##' ||
              (user && user.lastName == '##N/A##')
            ) {
              this.router.navigateByUrl(
                APP_ROUTES.authentication['personal-information'].fullPath
              );
              return false;
            }
            if (user.blocked) {
              this.router.navigateByUrl(
                APP_ROUTES.authentication.blocked.fullPath
              );
              return false;
            } else if (user.requiresPasswordChange) {
              this.router.navigateByUrl(
                APP_ROUTES.authentication['change-default-password'].fullPath
              );
              return false;
            }
          }
        }
        return true;
      })
    );

    // // if (!currentUser || currentUser == null) {
    // //   this.router.navigateByUrl(
    // //     `authentication/${AuthenticationRouteNames.signIn}`
    // //   );
    // //   return false;
    // // } else {
    // //   if (this.isSuperAdmin(currentUser?.roles || [])) {
    // //     return true;
    // //   } else {
    // //     if (
    // //       currentUser &&
    // //       !this.isSuperAdminOrManager(currentUser.roles) &&
    // //       currentUser.blocked == true
    // //     ) {
    // //       this.router.navigateByUrl('/authentication/blocked');
    // //       return false;
    // //     }
    // //     if (
    // //       currentUser.firstName &&
    // //       currentUser.confirmAccountToken &&
    // //       currentUser.confirmAccountToken !== null
    // //     ) {
    // //       this.router.navigateByUrl('/authentication/confirm-account');
    // //       return false;
    // //     }

    // //     if (currentUser && currentUser._companyId == null) {
    // //       this.router.navigateByUrl('/authentication/company-information');
    // //       return false;
    // //     }

    // //     if (
    // //       currentUser &&
    // //       currentUser.company &&
    // //       this.isSuperAdminOrManager(currentUser.roles) &&
    // //       !currentUser?.company?._subscription &&
    // //       currentUser?.blocked == false
    // //     ) {
    // //       this.router.navigateByUrl('/authentication/pick-plan');
    // //       return false;
    // //     }
    // //     if (currentUser && currentUser.requiresPasswordChange == true) {
    // //       this.router.navigateByUrl('/authentication/change-default-password');
    // //       return false;
    // //     }
    // //     // if (
    // //     //   (currentUser && currentUser.firstName == '##N/A##') ||
    // //     //   currentUser.lastName == '##N/A##'
    // //     // ) {
    // //     //   this.router.navigateByUrl('/authentication/personal-information');
    // //     //   return true;
    // //     // } else return true;
    // //   }

    //   // if (this.isSuperAdmin(currentUser.roles)) {
    //   //   this.router.navigateByUrl('/dashboard/home');
    //   //   return false;
    //   // }
    // }
    // return true;
  }

  isSuperAdminOrManager(roles: string[]) {
    if (roles) {
      let temp = roles.filter(
        (role) => role == 'super-admin' || role == Roles.companyAdministrator
      );
      if (temp.length > 0) return true;
      else return false;
    } else return false;
    // return roles.find((role: string) => {
    //     if (role == 'super-admin' || role == company-administrator') {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   });

    // else return false;
  }
}
